<div class="list-page">
  <div class="list-header">
    <h3>Remarks</h3>
    <div class="list-actions">
      <button mat-flat-button (click)="openDialogFilter()" class="secondary-button filter-btn"
              [class.filter-active]="filterCriteria.length > 0">
        <mat-icon>filter_list</mat-icon> Filter
        <span class="filter-count" *ngIf="filterCriteria.length > 0">{{ filterCriteria.length }}</span>
      </button>
      <button mat-stroked-button (click)="resetFilters()" class="clear-filter-btn"
              *ngIf="filterCriteria.length > 0">
        <mat-icon>close</mat-icon> Clear Filters
      </button>
    </div>
  </div>
  <app-list-container></app-list-container>
</div>
